import { memo, useState } from 'react'
import type { MouseEvent } from 'react'
import { useScrolled } from '../hooks/useScrolled'
import { scrollToSection as smoothScrollToSection } from '../utils/scroll'

export const Navbar = memo(function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const isScrolled = useScrolled()

  const scrollToSection = (id: string, event?: MouseEvent<HTMLAnchorElement>) => {
    event?.preventDefault()
    smoothScrollToSection(id)
    setIsMenuOpen(false)
  }

  return (
<nav className={`nav-stack ${isScrolled ? 'scrolled' : ''}`}>
  <div className="nav-content-stack">
    <div className="nav-logo-stack">
      <nav>
        <a href="/" className="logo">
          <img src="/logo.svg" alt="Logo" width="30" height="30" />
        </a>
      </nav>
    </div>

    <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
      <span className={isMenuOpen ? 'active' : ''}></span>
      <span className={isMenuOpen ? 'active' : ''}></span>
      <span className={isMenuOpen ? 'active' : ''}></span>
    </button>

    <div className={`nav-links-stack ${isMenuOpen ? 'open' : ''}`}>
      <a href="#hero" onClick={(e) => scrollToSection('hero', e)}>
        Home
      </a>
      <a href="#about" onClick={(e) => scrollToSection('about', e)}>
        About
      </a>
      <a href="#skills" onClick={(e) => scrollToSection('skills', e)}>
        Skills
      </a>
      <a href="#journey" onClick={(e) => scrollToSection('journey', e)}>
        Journey
      </a>
      <a href="#projects" onClick={(e) => scrollToSection('projects', e)}>
        Projects
      </a>
      <a href="#contact" onClick={(e) => scrollToSection('contact', e)}>
        Contact
      </a>
    </div>
  </div>
</nav>
  )
})
